import Story from "../components/Story/Story";
import Head from "next/head";

const About = () => {
  return (
    <div>
      <Head>
        <meta charset="utf-8" />
        <link rel="icon" href="/danMason.png" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta name="theme-color" content="#000000" />
        <meta name="description" content="Daniel Mason Full Stack Software Developer's Portfolio" />
        <title>About - Daniel Mason | Full Stack Software Developer</title>
      </Head>
      <Story />
    </div>
  );
};

export default About;
